<template>


  <div>
    <div
      id="uoloaddiv"
      v-loading.fullscreen.lock="loading"
      element-loading-text="Waiting...."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-row>
        <el-button
          class="topbuttn"
          size="medium"
          icon="el-icon-plus"
          @click="creatTask()"
          type="primary"
        >创建任务</el-button>
        <el-button
          class="topbuttn"
          size="medium"
          icon="el-icon-refresh"
          @click="_get_timer_tasklist"
          type="success"
        >手動刷新</el-button>
      </el-row>
      <br />
      <br />
      <el-table :data="tableDatatasklist" border>
        <el-table-column type="index" width="100px" label="编号"></el-table-column>
        <el-table-column prop="task_name" label="任务名" width="200px"></el-table-column>
        <el-table-column prop="start_time_" label="启动时间" width="100px"></el-table-column>
        <el-table-column prop="len" label="时长[秒]" width="100px"></el-table-column>
        <el-table-column prop="kind_" label="任务类型" width="130px"></el-table-column>
        <el-table-column prop="startdate_" label="开始日期" width="100px"></el-table-column>
        <el-table-column prop="enddate_" label="停止日期" width="100px"></el-table-column>
        <el-table-column label="[操作]-[使能]-[修改]" align="center" width="150px">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deletetask(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >移除</el-button>
            <el-switch
              active-value="1"
              inactive-value="0"
              v-model="tableDatatasklist[scope.$index].enable"
              @change="abletask( scope.$index, tableDatatasklist)"
            ></el-switch>
            <el-button
              @click.native.prevent="go_edit_task(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >修改</el-button>
          </template>
        </el-table-column>
        <el-table-column label="实时播放" align="center">
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.statu==0"
              @click.native.prevent="startTask(scope.$index, tableDatatasklist)"
              type="success"
              size="small"
              plain
            >启动</el-button>
            <el-button
              v-show="scope.row.statu==1"
              @click.native.prevent="stopTask(scope.$index, tableDatatasklist)"
              type="warning"
              size="small"
              plain
            >停止</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-dialog :title="dialog_titel" :visible.sync="dialogVisible_addtask" width="1000px">
        <el-form ref="form" :model="form" label-width="80px" align="left">
          <el-row class="fucko">
            <el-form-item label="任务名称">
              <el-col :span="20">
                <el-input v-model="form.name"></el-input>
              </el-col>
            </el-form-item>
          </el-row>

          <el-form-item label="节点选择">
            <el-select
              v-model="form.nodeid"
              @change="nodechange_"
              placeholder="请选择网络节点"
              :disabled="dialog_titel=='修改任务'"
            >
              <el-option
                v-for="(item,index) in tableData1"
                :label="item.node_name"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-row class="fucko">
            <el-form-item label="选择日期">
              <el-col :span="5">
                <el-checkbox v-model="checked1">启用开始日期</el-checkbox>
              </el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="form.startDate"
                  type="date"
                  placeholder="选择日期"
                  :disabled="!checked1"
                  :picker-options="pickerOptions1"
                ></el-date-picker>
              </el-col>
            </el-form-item>
          </el-row>

          <el-form-item>
            <el-row class="fucko">
              <el-col :span="5">
                <el-checkbox v-model="checked2">启用结束日期</el-checkbox>
              </el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  placeholder="选择日期"
                  :disabled="!checked2"
                  :picker-options="pickerOptions2"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>

          <el-row class="fucko">
            <el-col :span="10">
              <el-form-item label="播放模式">
                <el-select v-model="form.kind" @change="task_mode_change" placeholder="请选择任务类型">
                  <el-option label="顺序播放" value="1"></el-option>
                  <el-option label="随机播放" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="播放次数" v-show="form.kind==1" >
				    <el-input-number v-model="form.num" :min="1" @change="countLength"></el-input-number>

              </el-form-item>
            </el-col>
          </el-row>


          <el-form-item label="开始时间"  v-show="form.kind==1" >
            <el-time-picker v-model="form.startTime"
			@change='Timerpickerchange'
			placeholder="任意时间点" ></el-time-picker>
          </el-form-item>
		  <el-form-item label="时间选择"  v-show="form.kind==0" >
		    <el-time-picker v-model="form.timepicker"  is-range  range-separator="至"

          @change='Timerpickerchange2'

		  			placeholder="任意时间点" ></el-time-picker>
		  </el-form-item>

          <el-form-item label="间隔时长"  >
			   <el-tooltip
			    class="item"
			    effect="dark"
			    content="播放完一个节目之后间隔多少秒播放下一个条目"
			    placement="right-start"
			  >
            <el-input-number v-model="form.jiange" :min="1" @change="countLength"></el-input-number>
			</el-tooltip>
          </el-form-item>
          <el-form-item label="任务周期">
            <el-checkbox v-model="week[0]" name="type1">周一</el-checkbox>
            <el-checkbox v-model="week[1]" name="type2">周二</el-checkbox>
            <el-checkbox v-model="week[2]" name="type3">周三</el-checkbox>
            <el-checkbox v-model="week[3]" name="type4">周四</el-checkbox>
            <el-checkbox v-model="week[4]" name="type5">周五</el-checkbox>
            <el-checkbox v-model="week[5]" name="type6">周六</el-checkbox>
            <el-checkbox v-model="week[6]" name="type7">周日</el-checkbox>
          </el-form-item>

          <h3 style=" margin: 50px 0 20px">选择需要播放的设备</h3>
          <div >
            <el-transfer
              style="text-align: left; display: inline-block"
              v-model="form.seedlist.value"
              filterable
              :titles="['所有设备', '被播放的设备']"
              :button-texts="['移除', '添加']"
              :format="{
							noChecked: '${total}',
							hasChecked: '${checked}/${total}'
						  }"
              :data="form.seedlist.data"
            >
              <span slot-scope="{option}">{{ option.label }}</span>
            </el-transfer>
          </div>
          <h3 style="margin: 50px 0 20px">选择任务音频文件</h3>
          <div >
          <el-row>
            <div style="text-align: left;">




			 <myTransfer  style="text-align: left;  " v-model="form.filelist.value" :inputList="form.filelist.data">
			              <span slot-scope="{option}">{{ option.label }}</span>
			 </myTransfer>

      </div>

        </el-row>


          </div>
          <br>
            <el-row  >
              <el-form-item label="任务时长" v-show="form.kind==1" >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="以秒为单位;顺序播放次数循环时长如果比设置时长短会提前终止,以此处总时长为准,此处为0,则循环结束即停止;"
                  placement="right-start"
                >
                  <el-input-number v-model="form.len" :min="form.kind==1?0:600" :max="72000">
                  </el-input-number>
                </el-tooltip>
                <el-button @click="countLength">计算</el-button>
              </el-form-item>
          	</el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_addtask=false">取 消</el-button>
          <el-button type="primary" @click="save_task">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import myTransfer from './myTransfer.vue';
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
	return {

      loading: false,
      tableDatatasklist: [],
      dialogVisible_addtask: false,
      dialog_titel: "创建任务",
      checked1: "",
      checked2: "",
      is_create: true,
	  upDownDisable:true,
	  tempSelectionKeys:[],
	  outputListTemp:[],
      week: [true, true, true, true, true, true, true],
      form: {
        id: "",
        name: "",
        nodeid: "",
        startDate: "",
        endDate: "",
        estartDate: 0,
        eendDate: 0,
        kind: "1",
        num: 1,
        startTime: {},
        timepicker: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        len: 0,
        jiange: 0,
        weekStr: "",
        seedlist: {
          data: [],
          value: []
        },
        filelist: {
          data: [],
          value: []
        },
        taskEnable: "1"
      },
      tableData1: [],
      tableData2: [],
      tableDatafilelist: [],
      pickerOptions1: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            }
          },
          {
            text: "二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 60);
              picker.$emit("pick", date);
            }
          },
          {
            text: "三个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 91);
              picker.$emit("pick", date);
            }
          },
          {
            text: "六个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit("pick", date);
            }
          },
          {
            text: "十二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);

            }
          }
        ]
      },

      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            }
          },
          {
            text: "二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 60);
              picker.$emit("pick", date);
            }
          },
          {
            text: "三个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 91);
              picker.$emit("pick", date);
            }
          },
          {
            text: "六个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit("pick", date);
            }
          },
          {
            text: "十二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },

 watch:{
	 "form.filelist.value": {
        deep: true,
        handler: function (newVal,oldVal){
			this.countLength();
        }
      }
 },
  created() {
    this.get_devlist();
    this.get_file_list();
    this._get_timer_tasklist();
  },
    components: {
    myTransfer
  },
  methods: {
	   countfuck(){
	  },
	  countLength(){
		 var  lenmusic = 0;
		 var filelllist =this.tableDatafilelist;
		 this.form.filelist.value.forEach( function(item){
			filelllist.forEach(function(jitem){
				if(jitem.id == item){
					lenmusic = Number(lenmusic)+ Number(jitem.len);
				}
			})
        });
		var jiangelen = Number(this.form.jiange)*Number(this.form.num);
		lenmusic = Number(lenmusic)*Number(this.form.num);
		this.form.len = Number(jiangelen)+Number(lenmusic);

	  },
	  Timerpickerchange(){
		  console.log(this.form.startTime);
	  },
	  Timerpickerchange2(){
      console.log(this.form.timepicker[0]);
      console.log(this.form.timepicker[1]);

	  },
	  handleTransfer(type, data, callback) {
	    if (type == 'left') {
	      this.form.filelist.data = this.form.filelist.data.concat(this.form.filelist.value[data]);
	    } else {
	      this.form.filelist.value = this.form.filelist.value.concat(this.form.filelist.data[data])
	    }
	    this[type + 'Data'].splice(data, 1);
	    callback(type);
	  },
	  handleSort(type, sortType, data, callback) {
	    if (!sortType || sortType == 'right') {
	      if (type == 'up') {
	        this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] - 1)
	        callback(sortType, [data[0], data[1] - 1]);
	      } else {
	        this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] + 1)
	        callback(sortType, [data[0], data[1] + 1])
	      }
	    } else if (sortType == 'left') {
	      if (type == 'up') {
	        this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] - 1)
	        callback(sortType, [data[0] - 1, data[1]]);
	      } else {
	        this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] + 1)
	        callback(sortType, [data[0] + 1, data[1]])
	      }
	    } else if (sortType == 'both') {
	      if (type == 'up') {
	        data[0] == 0 ? '' : this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] - 1)
	        data[1] == 0 ? '' : this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] - 1)
	        callback(sortType, [data[0] == 0 ? data[0] : (data[0] - 1), data[1] == 0 ?  data[1] : (data[1] - 1)]);
	      } else {
	        data[0] == (this.form.filelist.value.length - 1) ? '' : this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] + 1)
	        data[1] == (this.form.filelist.data.length - 1) ? '' : this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] + 1)
	        callback(sortType, [data[0] == (this.form.filelist.value.length - 1) ? data[0] : (data[0] + 1), data[1] == (this.form.filelist.data.length - 1) ? data[1] : (data[1] + 1)])
	      }
	    }
	  },
	  swapItems(arr, index1, index2) {
	    arr[index1] = arr.splice(index2, 1, arr[index1])[0];
	    return arr;
	  },
    stopTask(index, rows) {
      this.loading = true;

      axios
        .get("/Startstoptask.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            taskid: rows[index].id,
            statu: 2
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
            }
            setTimeout(() => {
              this.loading = false;
              this._get_timer_tasklist();
            }, 4000);
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    startTask(index, rows) {
      this.loading = true;

      axios
        .get("/Startstoptask.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            taskid: rows[index].id,
            statu: 1
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
            }
            setTimeout(() => {
              this.loading = false;
              this._get_timer_tasklist();
            }, 3000);
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
	rightCheck(selectionKeys, changeKeys){
            	this.tempSelectionKeys = selectionKeys;
            	if(selectionKeys.length > 0){
            		this.upDownDisable = false;
            	}else{
            		this.upDownDisable = true;
            	}
            },
            upData(){
				if(this.tempSelectionKeys.length > 1){
					this.$message({
						type: 'warning',
						message: '仅支持单选调顺序'
					});
					return ;
				}
            	let indexNum = 0;
            	for(let i=0; i<this.tempSelectionKeys.length; i++){
            		indexNum = this.form.filelist.value.indexOf(this.tempSelectionKeys[i])
            		if(indexNum > 0){
            			this.form.filelist.value.splice(indexNum - 1, 0, this.tempSelectionKeys[i]);
            			this.form.filelist.value.splice(indexNum + 1, 1);
            		}
            	}
            },
            downData(){
				if(this.tempSelectionKeys.length > 1){
					this.$message({
						type: 'warning',
						message: '仅支持单选调顺序'
					});
					return ;
				}
            	let indexNum = 0;
            	for(let i=0; i<this.tempSelectionKeys.length; i++){
            		indexNum = this.form.filelist.value.indexOf(this.tempSelectionKeys[i]);
            		if(indexNum > -1 && indexNum != this.form.filelist.value.length - 1){
            			this.form.filelist.value.splice(indexNum + 2, 0, this.tempSelectionKeys[i]);
            			this.form.filelist.value.splice(indexNum, 1);
            		}
            	}
            },
      go_edit_task(index, rows) {
      console.log(rows[index]);
      this.form.id = rows[index].id;
      this.form.name = rows[index].task_name;
      this.form.nodeid = rows[index].nodeid;
      this.form.kind = rows[index].kind;
      this.form.num = rows[index].kind;
      this.form.len = rows[index].len;
      this.form.jiange = rows[index].jiange;
      this.form.taskEnable = rows[index].enable;
      this.is_create = false;

      if (rows[index].startdate_ == "无限制") {
        this.checked1 = false;
      } else {
        this.checked1 = true;
        this.form.startDate = rows[index].startdate_;
      }
      if (rows[index].enddate_ == "无限制") {
        this.checked2 = false;
      } else {
        this.checked2 = true;
        this.form.endDate = rows[index].enddate_;
      }
      if (rows[index].kind != "0" && rows[index].kind != "1") {
        this.form.kind = "1";
      }
      var stattTime1 = parseInt(rows[index].start_time) * 1000;
      var stattTime2 = parseInt(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      this.form.startTime = new Date(stattTime2 + stattTime1);
      var dte2 = new Date(this.form.startTime.getTime()+parseInt(rows[index].len)*1000);
      var dateary=[];
      if(rows[index].kind == 0){
        dateary.push(this.form.startTime);
        dateary.push(dte2);
        this.form.timepicker = dateary;
      }
      for (var i = 0; i < rows[index].week.length; i++) {
        if (rows[index].week.charAt(i) == 0) {
          this.week[i] = false;
        } else {
          this.week[i] = true;
        }
      }
      this.nodechange_();
      this.get_file_list();
      this.dialog_titel = "修改任务";
      this.dialogVisible_addtask = true;
      this.form.seedlist.value = rows[index].seedidary;
      this.form.filelist.value = rows[index].fileidary;
    },
    task_mode_change() {
      if(this.form.kind == "0") {
          this.form.num = 0;
          this.form.jiange = 0;
              if(this.form.len<10){
            this.form.len=10;
        }
      }else{
        this.form.num = 1;
        this.form.len = 0;
      }
    },
    save_task() {
      if (this.form.name == "") {
        this.$message({
          type: "warning",
          message: "任务名字不能为空"
        });
        return;
      }
      if (this.form.nodeid == "") {
        this.$message({
          type: "warning",
          message: "没有选择该任务的网络节点"
        });
        return;
      }
      if (this.form.seedlist.value.length == 0) {
        this.$message({
          type: "warning",
          message: "没有选择播放设备"
        });
        return;
      }
      if (this.form.filelist.value.length == 0) {
        this.$message({
          type: "warning",
          message: "没有选择播放的音频文件"
        });
        return;
      }
      if (this.form.kind == "0") {
        this.form.startTime =  this.form.timepicker[0];
      }
      if (this.form.startTime == null || this.form.startTime == 0) {
        this.$message({
          type: "warning",
          message: "没有选择播放开始时间"
        });
        return;
      }
      if (this.form.kind == "") {
        this.$message({
          type: "warning",
          message: "没有选择播放模式"
        });
        return;
      }
      console.log("this.form.kind ==>",this.form.kind);
       console.log(this.form.kind);
       console.log("================");
      if (!this.checked1) {
        this.form.estartDate = 0;
      } else if (this.form.startDate != "") {
        var datestart = new Date(this.form.startDate);
        this.form.estartDate = parseInt(
          datestart.getTime() / (3600 * 24 * 1000)
        );
      } else {
        this.form.estartDate = 0;
      }
      if (!this.checked2) {
        this.form.eendDate = 0;
      } else if (this.form.endDate != "") {
        var dateend = new Date(this.form.endDate);
        this.form.eendDate = parseInt(dateend.getTime() / (3600 * 24 * 1000));
      } else {
        this.form.eendDate = 0;
      }
      if (this.form.kind == "1") {

        if (this.form.len < 600) {
          this.form.len = 600;
        }
      }

      // if (this.form.kind == "0") {
      //   this.Timerpickerchange2();
      //   if (this.form.len < 10) {
      //     this.form.len = 10;
      //   }
      //   this.form.num=0;
      // }



      if (this.form.kind == "0") {
        this.form.startTime =  this.form.timepicker[0];
        var l1 = this.form.timepicker[0].getTime()/1000;
        var l2 = this.form.timepicker[1].getTime()/1000;
        this.form.len = l2 - l1;
        if (this.form.len < 10) {
          this.form.len = 10;
        }
        this.form.num=0;
      }
      for (var i = 0; i < this.week.length; i++) {
        if (this.week[i]) {
          this.week[i] = 1;
        } else {
          this.week[i] = 0;
        }
      }
      this.form.weekStr = "";
      for (var i = 0; i < this.week.length; i++) {
        this.form.weekStr += this.week[i];
      }

      var date = new Date(this.form.startTime);
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var start_time = h * 3600 + m * 60 + s;
      var j = 0;
      var len = 0;
      var arrseed = [];
      for (var i in this.form.seedlist.value) {
        arrseed.push(this.form.seedlist.value[i]);
      }
      var seedidlist = arrseed.join("|");
      var arrfile = [];
      for (var i in this.form.filelist.value) {
        arrfile.push(this.form.filelist.value[i]);
      }
      var fileidlist = arrfile.join("|");
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("seedlist", seedidlist);
      data.append("filelist", fileidlist);
      if (this.is_create == false) {
        data.append("task_id", this.form.id);
      }
      data.append("week", this.form.weekStr);
      data.append("kind", this.form.num);
      data.append("nodeid", this.form.nodeid);
      data.append("start_time", start_time);
      data.append("task_name", this.form.name);
      data.append("len", this.form.len);
      data.append("jiange", this.form.jiange);
      data.append("startdate", this.form.estartDate);
      data.append("enddate", this.form.eendDate);
      data.append("enable", 0);
      console.log(data.get("startdate"));
      console.log(data.get("startdate") + 1);
      axios
        .post("/add_save_taskweb.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_addtask = false;
      this.form = {
        id: "",
        name: "",
        nodeid: "",
        startDate: "",
        endDate: "",
        estartDate: 0,
        eendDate: 0,
        kind: "1",
        num: 1,
        startTime: {},
        timepicker: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        len: 0,
        weekStr: "",
        seedlist: {
          data: [],
          value: []
        },
        filelist: {
          data: [],
          value: []
        }
      };
    },
    creatTask() {
      this.dialog_titel = "创建任务";
      this.get_file_list();
      this.dialogVisible_addtask = true;
      this.week = [true, true, true, true, true, true, true];
      this.form.startDate = "";
      this.form.endDate = "";
      this.is_create = true;
      this.form.startTime = "";
    },
    nodechange_() {
      axios
        .get("/get_user_nodedev.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            nodeid: this.form.nodeid
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.form.seedlist.data = res.data.dev_info;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1;
    },
    kind_change(data) {
      if (data === "1") {
        this.timepickerVisible = true;
      } else {
        this.timepickerVisible = false;
      }
    },
    str_pull(data) {
      let str = "";
      data.forEach((item, index) => {
        str += item;
        str += "|";
      });
      return str.substring(0, str.length - 1);
    },

    _get_timer_tasklist() {
      axios
        .get("/Get_list_of_time_taskweb.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatatasklist = res.data.dataJson;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    add_taskadd() {
      this.dialog_titel = "添加任务";
      axios
        .get("/get_addtask_needs.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.form.data2 = res.data.devices;
              this.form.data3 = res.data.files;
              this.form.data3.forEach((item, index) => {
                this.form.data3[index].label = Base64.decode(item.label);
              });
              this.dialogVisible_addtask = true;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    deletetask(index, rows) {
      if (rows[index].enable != 0) {
        this.$message({
          type: "warning",
          message: "请先禁用该任务"
        });
        return;
      }

      this.$confirm(
        "此操作将永久删除该任務, 是否继续?" + rows[index].task_name,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(function() {
          console.log(rows[index].enable);

          let task_id = rows[index].id;
          axios
            .get("/del_taskweb.php", {
              params: {
                username: sessionStorage.getItem("username"),
                passwd: sessionStorage.getItem("passwd"),
                task_id: rows[index].id
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  rows.splice(index, 1);
                  this._get_timer_tasklist();
                  this.$message({
                    type: "success",
                    message: "删除成功!" + filename
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {});
    },
    detailtask(index, rows) {
      this.dialog_titel = "查看/编辑 任务";
      axios
        .get("/get_task_detail.php", {
          params: {
            task_id: rows[index].id
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.form = res.data.dataJson;
              this.form.time = new Date(
                2019,
                2,
                2,
                res.data.dataJson.time.h,
                res.data.dataJson.time.m
              );
              axios
                .get("/get_addtask_needs.php")
                .then(
                  function(res) {
                    if (res.data.res) {
                      this.form.data2 = res.data.devices;
                      this.form.data3 = res.data.files;
                      this.form.data3.forEach((item, index) => {
                        this.form.data3[index].label = Base64.decode(
                          item.label
                        );
                      });
                      this.dialogVisible_addtask = true;
                      this.$forceUpdate();
                    }
                  }.bind(this)
                )
                .catch(function(res) {
                  console.log(res);
                });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    abletask(index, rows) {
      let task_id = rows[index].id;
      axios
        .get("/Change_task_statusweb.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            task_id: rows[index].id,
            task_enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    _get_timer_tasklist_s( e,i) {
      axios
        .get("/Get_list_of_time_task.php")
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res);
              this.tableDatatasklist = res.data.dataJson;
              if (e === "1") {
                this.$message({
                  type: "success",
                  message: "已生效!" + this.tableDatatasklist[i].task_name
                });
              } else {
                this.$message({
                  type: "success",
                  message: "已经禁用!" + this.tableDatatasklist[i].task_name
                });
              }
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_devlist: function() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData1 = res.data.dataJson;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              const data = [];
              for (let i = 0; i < this.tableDatafilelist.length; i++) {
                data.push({
                  key: this.tableDatafilelist[i].id,
                  label: this.tableDatafilelist[i].filename
                });
              }
              this.form.filelist.data = data;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.topbuttn {
  width: 200px;
}
#uoloaddiv {
  width: 1100px;
  margin: 20px auto;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.el-button .el-switch {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/task_list.vue